import { ValidatorFn, AbstractControl } from "@angular/forms";


export function minArrayLength(min: number): ValidatorFn {
    return (ctrl: AbstractControl): { [key: string]: any } | null => {
        const value: [] = ctrl.value;
        if (value != null && value.length >= min) return null;
        return { MinArrayLength: true };
    };
}

export function maxArrayLength(max: number): ValidatorFn {
    return (ctrl: AbstractControl): { [key: string]: any } | null => {
        const value: [] = ctrl.value;
        if (value != null && value.length <= max) return null;
        return { MaxArrayLength: true };
    };
}

export function requiredNull(): ValidatorFn {
    return (ctrl: AbstractControl): { [key: string]: any } | null => {
        if (ctrl.value == null) return null;
        return { RequiredNull: true };
    }
}

export function isInArray(values: any[]): ValidatorFn {
    return (ctrl: AbstractControl): { [key: string]: any } | null => {
        let result: boolean = false;
        if (ctrl.value != null) {
            result = values.includes(ctrl.value);
        }
        return (result) ? null : { isInArray: true };
    }
}